import { useSearchParams } from 'react-router-dom';
import { SEARCH_SUCCESS, useHelpNode, useHelpSearch } from '@ergeon/help-components';

import { authService } from 'common/auth';

import { WIKI_API_HOST, WIKI_DOMAIN } from '../constants';

const WIKI_REQUEST = { apiHost: WIKI_API_HOST, auth: authService, domain: WIKI_DOMAIN };

const useWikiSearch = () => {
  const [searchParams] = useSearchParams();
  const query = (searchParams.get('q') || '').trim();
  const localNodeKey = searchParams.get('local') || undefined;
  const search = useHelpSearch({ ...WIKI_REQUEST, localNodeKey, query });
  const scope = useHelpNode({ ...WIKI_REQUEST, nodeKey: localNodeKey });

  return {
    hasResults: search.status === SEARCH_SUCCESS && !search.isLoading,
    localNodeKey,
    localTitle: scope.node?.title,
    query,
    search,
  };
};

export default useWikiSearch;
